// Estado de las webs publicadas (monitor de disponibilidad).
import { useEffect, useState } from 'react';
import { api, type Status } from '../../api.ts';
import { t } from '../../i18n/index.ts';
import { errorText, useApp } from '../../store.ts';
import { ago } from '../../format.ts';
import { navigate } from '../../router.ts';

export function StatusPage() {
  const notify = useApp((s) => s.notify);
  const [status, setStatus] = useState<Status | null>(null);

  useEffect(() => {
    const load = () => api.status().then(setStatus).catch((e) => notify(errorText(e), true));
    void load();
    const timer = setInterval(load, 30_000);
    return () => clearInterval(timer);
  }, [notify]);

  if (!status) return null;
  return (
    <section className="section">
      <h2>{t('ws.status')}</h2>
      <p className="hint">{status.monitorMinutes > 0 ? t('status.hint', { n: status.monitorMinutes }) : t('status.off')}</p>
      {status.sites.length === 0 ? <p className="hint">{t('status.none')}</p> : null}
      <div className="list">
        {status.sites.map((s) => (
          <button key={s.id} type="button" className="list-row" style={{ border: 0, borderTop: '1px solid var(--border)', background: 'transparent', cursor: 'pointer', textAlign: 'left', width: '100%' }} onClick={() => navigate(`/sites/${s.id}/domains`)}>
            <span className={`dot ${s.state === 'up' ? 'up' : s.state === 'down' ? 'down' : ''}`} />
            <span className="grow ellipsis" title={s.name}>
              {s.name}
            </span>
            <span className="muted">{s.uptime24h === null ? '—' : `${(s.uptime24h * 100).toFixed(s.uptime24h === 1 ? 0 : 2)}%`}</span>
            <span className="hint">{s.last ? t('status.last', { when: ago(s.last.at), code: s.last.status ?? '—', ms: s.last.ms ?? '—' }) : t('status.noChecks')}</span>
          </button>
        ))}
      </div>
    </section>
  );
}
